module.exports = __webpack_public_path__ + "saira-bold-webfont.8aeabba4c00efbeb7b8f.woff2";


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/BEX-VoucherAdmin/src/assets/fonts/saira-bold-webfont.woff2
// module id = ../../../../../src/assets/fonts/saira-bold-webfont.woff2
// module chunks = styles